module.exports = __webpack_public_path__ + "img/comencemos.c43ce5ba.png";